export default function accordion(firstState: number) {
  return {
    currentlyOpened: firstState,
    toggleOpen(index: number) {
      this.currentlyOpened = this.currentlyOpened !== index ? index : 0;
    },
    isOpened(index: number) {
      return this.currentlyOpened === index;
    },
  };
}
